import { render, staticRenderFns } from "./LotActions.vue?vue&type=template&id=6ad584a6&scoped=true"
import script from "./LotActions.vue?vue&type=script&lang=ts"
export * from "./LotActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad584a6",
  null
  
)

export default component.exports